import { Badge, UncontrolledTooltip} from 'reactstrap'

const TooltipInfoCreoModifico = (props) => {

  const { 
    idregistro, 
    usuario_creo, 
    fecha_creo, 
    usuario_modifico, 
    fecha_modifico 
  } = props

  return (
    <>
      <Badge
        id={'tooltip_' + idregistro}
        color='secondary'
      >
        <i className="nc-icon nc-alert-circle-i" />
      </Badge>

      <UncontrolledTooltip
        modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
        autohide={false}
        delay={{ show: 200, hide: 5 }}
        placement='right'
        target={'tooltip_' + idregistro}
      >
        Usuario Creo: {usuario_creo}
        <br></br>
        Fecha Creo: {fecha_creo}
        <br></br>
        Usuario Modifico: {(usuario_modifico != null ? usuario_modifico : '')}
        <br></br>
        Fecha Modifico: {(fecha_modifico != null ? fecha_modifico : '')}
      </UncontrolledTooltip>
    </>
  )
}

export {
    TooltipInfoCreoModifico
}